var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.77d1b0e97b4ba816cb6d33a3b550ea77.svg#v';
                    var viewUrl = 'sprites.77d1b0e97b4ba816cb6d33a3b550ea77.svg#view-v';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 43 46',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };